import React from 'react';
import { Translate } from 'react-redux-i18n';
import FlexibleImage, { ImageShape } from './FlexibleImage';

interface LabeledImageProps {
  /** Primary image URL */
  imageUrl?: string;
  /** Fallback image URLs in order of preference */
  fallbackImageUrls?: string[];
  /** Translation key for the image label */
  labelTranslationKey: string;
  /** Alternative text for the image (fallback if translation fails) */
  altText?: string;
  /** Size of the image */
  size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';
  /** Shape of the image */
  shape?: ImageShape;
  /** Custom margin bottom (defaults to 20px) */
  marginBottom?: string;
  /** Whether to show bold label (defaults to true) */
  showBoldLabel?: boolean;
}

export const LabeledImage: React.FC<LabeledImageProps> = ({
  imageUrl,
  fallbackImageUrls = [],
  labelTranslationKey,
  altText = '',
  size = 'small',
  shape = 'rounded',
  marginBottom = '20px',
  showBoldLabel = true
}) => {
  // Check if there's a valid image to render
  const hasValidImage = imageUrl || fallbackImageUrls.length > 0;
  
  if (!hasValidImage) {
    return null;
  }

  const containerStyle: React.CSSProperties = {
    marginBottom,
    ...(showBoldLabel && { fontWeight: 'bold' })
  };

  return (
    <div style={containerStyle}>
      <Translate value={labelTranslationKey} />
      <FlexibleImage
        imageUrl={imageUrl}
        fallbackImageUrls={fallbackImageUrls}
        alt={altText}
        size={size}
        shape={shape}
      />
    </div>
  );
};

export default LabeledImage;
